// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.91.0',
  revision: '18aa096e1',
  branch: 'master',
  date: 'Wed, 07 Oct 2026 12:09:40 GMT'
};